.pinCard {
  display: flex;
  position: relative;
  height: 44px;
  justify-content: flex-start;
  align-items: center;
  padding: 0 var(--spacing-08);
  gap: var(--spacing-04);
  background-color: var(--sparky-brand-white);
  flex-shrink: 0;

  &.editingPinCard {
    background-color: var(--sparky-grey-100);
  }

  &:hover:not([data-disabled='true']) {
    cursor: pointer;
    background-color: var(--sparky-grey-100);
  }

  .disabledText {
    color: var(--sparky-grey-300);
  }

  .doneEditingButton {
    background-color: unset !important;
  }

  .editButton {
    position: absolute;
    top: 50%;
    right: var(--spacing-08);
    transform: translateY(-50%);
  }
}
